import { render, staticRenderFns } from "./BestStore.vue?vue&type=template&id=ef515a74&scoped=true"
import script from "./BestStore.vue?vue&type=script&lang=js"
export * from "./BestStore.vue?vue&type=script&lang=js"
import style0 from "./BestStore.vue?vue&type=style&index=0&id=ef515a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef515a74",
  null
  
)

export default component.exports